var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title"},[(_vm.showBorder)?_c('span',{staticClass:"icon"}):_vm._e(),_c('span',{staticClass:"zh"},[_vm._v(_vm._s(_vm.zh))]),_c('span',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))])]),_c('span',{staticClass:"more",on:{"click":_vm.toMore}},[_vm._v("更多>>")])])
}
var staticRenderFns = []

export { render, staticRenderFns }